const REPUBLISH_MESSAGE =
  "Changing the URL slug republishes your live site. This may take a minute. Continue?";

export async function confirmSlugRepublishIfNeeded(
  isLive: boolean,
  slugChanged: boolean,
): Promise<boolean> {
  if (!isLive || !slugChanged) return true;
  return window.confirm(REPUBLISH_MESSAGE);
}
